var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 79,
    viewBox: "0 0 63 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1081 3.66081C37.2044 3.68287 37.2957 3.70377 37.3933 3.72068L38.0763 0.686182C38.178 0.227307 38.6317 -0.0643137 39.0821 0.0441896L39.1633 0.062769C39.6147 0.166116 39.8966 0.626108 39.7938 1.09014L39.105 4.15042C55.1112 8.52943 64.9915 24.9902 61.386 41.5981C60.1259 39.6357 58.1538 38.1441 55.7312 37.5787C53.2783 37.0064 50.8308 37.4917 48.8436 38.7379L48.8386 38.7368L48.59 38.6799C46.4668 36.379 43.6735 34.6724 40.4241 33.9177C37.3674 33.2072 34.3262 33.4374 31.5632 34.4085L22.7286 74.991C24.2352 75.5526 25.2799 76.9239 25.474 78.5015L17.3338 78.5015C17.3338 76.4807 19.6965 74.7953 21.0853 74.734L30.0352 33.6308C28.0309 31.7797 25.5519 30.4105 22.7286 29.7534C19.4336 28.9883 16.1468 29.2923 13.2152 30.4469L13.0326 30.4051C13.0906 30.2396 13.1463 30.0844 13.2043 29.9189C13.1474 30.0793 13.0866 30.2333 13.0349 30.3948C11.7734 28.4862 9.83278 27.0452 7.4559 26.4903C5.07902 25.9354 2.70385 26.3831 0.751358 27.5451L0.675266 27.5277C4.53879 10.838 20.6957 0.321061 37.112 3.66713L37.1081 3.66081Z",
    fill: "#E4DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f0af1546af9d10a83f161109c5f5671f.svg";
export { ForwardRef as ReactComponent };